/**
 * Shared account-avatar rendering — one source for the initials fallback and
 * the data-URI <img> path, used by the toolbar chip, account panel, settings
 * Account pane, and profile modal.
 *
 * Security note: the avatar is only ever assigned via the .src PROPERTY of a
 * created <img> (never string-interpolated into HTML), and only when it looks
 * like an image data URI.
 */

/** Initials from the best available identity (display name > email > sub). */
export function accountInitials(profile, authPayload) {
  const name =
    profile?.displayName || authPayload?.email || profile?.email || authPayload?.sub || '?';
  const base = String(name)
    .replace(/[^A-Za-z0-9]+/g, ' ')
    .trim();
  const parts = base.split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] || '?') + (parts[1]?.[0] || '')).toUpperCase();
}

/** The display label: display name, else the email, else the sub. */
export function accountLabel(profile, authPayload) {
  return profile?.displayName || authPayload?.email || profile?.email || authPayload?.sub || '';
}

function isAvatarUri(value) {
  return typeof value === 'string' && value.startsWith('data:image/');
}

/**
 * Render the avatar (img or initials) into a host element.
 * @param {HTMLElement} host — emptied and refilled
 */
export function renderAvatarInto(host, { profile = null, authPayload = null } = {}) {
  if (!host) return;
  host.textContent = '';
  if (isAvatarUri(profile?.avatar)) {
    const img = document.createElement('img');
    img.alt = '';
    img.className = 'pb-account-avatar-img';
    img.src = profile.avatar;
    host.appendChild(img);
    return;
  }
  host.textContent = accountInitials(profile, authPayload);
}
